module.exports = __webpack_public_path__ + "static/presskit-title-4b435e93e6ad0db468f97e186a7f494e.jpg";